import { dataEllipsis } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEllipsis = /*#__PURE__*/createIcon(dataEllipsis)
export default IconEllipsis
